import React, { useRef, useState } from 'react';
import { Search } from 'lucide-react';
import './BoardClickUpFilterChip.css';
import './BoardToolbarSearchFilters.css';

/** Campo de pesquisa que expande ao hover/foco — toolbar Board. */
export function BoardToolbarExpandSearch({
  value = '',
  onChange,
  placeholder = 'Pesquisar...',
  ariaLabel = 'Pesquisar ordens de serviço',
  forceExpanded = false,
}) {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const expanded = forceExpanded || focused || String(value).length > 0;

  return (
    <div
      className={[
        'board-toolbar-expand-search',
        expanded ? 'is-expanded' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      onMouseDown={() => {
        window.requestAnimationFrame(() => inputRef.current?.focus());
      }}
    >
      <span className="board-toolbar-expand-search-icon" aria-hidden="true">
        <Search size={13} strokeWidth={1.75} />
      </span>
      <input
        ref={inputRef}
        type="text"
        className="board-toolbar-expand-search-input"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  );
}
